import { render } from "./FilterSection.vue?vue&type=template&id=3548c83e&ts=true"
import script from "./FilterSection.vue?vue&type=script&lang=ts"
export * from "./FilterSection.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Vyvoj\\temporary\\htdocs\\dev.poski.loc\\clevero.cz\\trunk\\www\\frontend\\CID\\dekstone\\klasik-2020\\js\\libraries\\store-catalog\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__